import { useContext, useEffect } from 'react';
import { SmartContext } from '../../../library/Core/SmartContext';
import { isEmpty } from '../../../library/Core/SmartFunctions';
import BarChartCommonComponent from '../../../library/SimpleControls/BarChartCommonComponent';
import useDashboard from './useDashboard';

const JobByLocation = () => {
    const { state } = useContext(SmartContext);
    const { getJobByLocation } = useDashboard();

    useEffect(() => {
        getJobByLocation();
    }, []);

    if (isEmpty(state?.data?.dashboardData?.jobByLocation))
    return (
        <>
            <div>No Data Available</div>
        </>
    );

    return (
        <>
            <BarChartCommonComponent data={state?.data?.dashboardData?.jobByLocation} />
        </>
    );
};

export default JobByLocation;
